import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

interface IProps extends IIcon {
    secondaryFill?: string;
}

export const FloorLowerIcon = (props: IProps) => {
    const {secondaryFill = "#E5E5E6"} = props;

    return (
        <SvgIcon {...props}>
            <path d="M 1 7 L 9 7 L 9 9 L 1 9 Z M 1 7" fill={secondaryFill} />
            <path d="M 1 5 L 9 5 L 9 7 L 1 7 Z M 1 5" />
            <path d="M 1 3 L 9 3 L 9 5 L 1 5 Z M 1 3" fill={secondaryFill} />
            <path d="M 1 1 L 7 1 L 7 3 L 1 3 Z M 1 1" fill={secondaryFill} />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

interface IProps extends IIcon {
    secondaryFill?: string;
}

export const FloorLowerIcon = (props: IProps) => {
    const {secondaryFill = "#E5E5E6"} = props;

    return (
        <SvgIcon {...props}>
            <path d="M 1 7 L 9 7 L 9 9 L 1 9 Z M 1 7" fill={secondaryFill} />
            <path d="M 1 5 L 9 5 L 9 7 L 1 7 Z M 1 5" />
            <path d="M 1 3 L 9 3 L 9 5 L 1 5 Z M 1 3" fill={secondaryFill} />
            <path d="M 1 1 L 7 1 L 7 3 L 1 3 Z M 1 1" fill={secondaryFill} />
        </SvgIcon>
    );
};
